import React, { Component } from 'react'
import { Table, Row, Col, Button, Icon, Input } from 'antd';
import { CSVLink  } from 'react-csv';
import _ from 'underscore';

export default class WorkHomeLeaveSummary extends Component {

    constructor( props ){
        super( props );

        this.state = {
            data                    : [],
            download_csv            : [],
            company_filter          : [{ text: 'None', value: 'None' }],
            department_filter       : [{ text: 'None', value: 'None' }]
        }

        this.convert_to_csv = this.convert_to_csv.bind( this );
        this.generate_year_range = this.generate_year_range.bind( this );
        this.handleDownload = this.handleDownload.bind( this );

    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}>
                    Search
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>Reset</Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) => 
            record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                    setTimeout(() => this.searchInput.select() );
                } 
            }
            
    });

    handleSearch = (selectedKeys, confirm) => {
        confirm();
        this.setState({ searchText: selectedKeys[0] });
    }
    
    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    }

    componentWillMount(){
    
        this.setState({ data: this.props.onData });
        this.convert_to_csv( this.props.onData );

        this.setState({
            company_filter: this.props.onCompany
        });

    }

    convert_to_csv( data ){

        let temp_data = [];

        data.map( ( item, k ) => {

            item.summary.map( ( value, i ) => {
                
                value.leave_detail.map( ( val, j ) => {

                    val.dates.map( ( dates, key ) => {

                        let stack = {
                            "full_name": item.full_name,
                            "company": item.company,
                            "employee_status": item.employee_status,
                            "date_of_joining": item.date_of_joining,
                            "date_of_exit": item.date_of_exit,
                            "year": value.year,
                            "joining_date": value.joining_date,
                            "year_end": value.year_end,
                            "total_number_of_days": value.total_number_of_days,
                            "no_of_months": value.no_of_months,
                            "acquired_days_per_month": value.acquired_days_per_month,
                            "yearly_leave_benefit": value.yearly_leave_benefit,
                            "total_leave_benefit": value.total_leave_benefit,
                            "total_leave_taken": value.total_leave_taken,
                            "unused_leaves": value.unused_leaves,
                            "used_year": dates.year,
                            "used_month": dates.month,
                            "used_date": dates.date,
                            "used_day": dates.day
                        }
        
                        temp_data.push( stack );

                    });

                });

            });

        });

        this.setState({ download_csv: temp_data });

    }

    generate_year_range(start, end){
        let years = [];
        for(let year = start; year <= end; year++){
            years.push(
                { "year" : year }
            )
        }
        return years;
    }

    handleDownload( data ){
        console.log( data );
    }

    
    handletotal_leave_benefit( data ){

        if( data.summary ){

            if( data.summary[data.summary.length-1].year !== new Date().getFullYear() ){

                if( data.summary.length != 1 ){
                    return data.summary[data.summary.length-2].total_leave_benefit
                } else {
                    return 0;
                }

            } else {
                return data.summary[data.summary.length-1].total_leave_benefit
            }
            
        }

    }

    handletotal_leave_taken( data ){

        if( data.summary ){

            if( data.summary[data.summary.length-1].year !== new Date().getFullYear() ){

                if( data.summary.length != 1 ){
                    return data.summary[data.summary.length-2].total_leave_taken
                } else {
                    return 0;
                }

            } else {
                return data.summary[data.summary.length-1].total_leave_taken
            }
            
        }

    }

    handlecurrent_leave_balance( data ){

        if( data.summary ){

            if( data.summary[data.summary.length-1].year !== new Date().getFullYear() ){

                if( data.summary.length != 1 ){
                    return data.summary[data.summary.length-2].unused_leaves
                } else {
                    return 0;
                }

            } else {
                return data.summary[data.summary.length-1].unused_leaves
            }
            
        }

    }


    render() {

        const headers = [
            {label: "Employee Name",  key: "full_name"},
            {label: "Company", key: "company"},
            {label: "Employee Status", key: "employee_status"},
            {label: "Date of Joining", key: "date_of_joining"},
            {label: "Date of Exit", key: "date_of_exit"},
            {label: "Year", key: "year"},
            {label: "Joining Date", key: "joining_date"},
            {label: "Year End", key: "year_end"},
            {label: "Total Number of Days", key: "total_number_of_days"},
            {label: "No of Months", key: "no_of_months"},
            {label: "Acquired Days Per Month", key: "acquired_days_per_month"},
            {label: "Yearly Leave Benefit", key: "yearly_leave_benefit"},
            {label: "Total Leave Benefit", key: "total_leave_benefit"},
            {label: "Total Leave Taken", key: "total_leave_taken"},
            {label: "Unused Leaves", key: "unused_leaves"},
            {label: "Used Year", key: "used_year" },
            {label: "Used Month", key: "used_month" },
            {label: "Used Date", key: "used_date" },
            {label: "used Day", key: "used_day" }
        ];

        const columns = [
            {
                title: 'Name of Employee',
                dataIndex: 'full_name',
                key: 'full_name',
                ...this.getColumnSearchProps( 'full_name' )
            },
            {
                title: 'Company',
                dataIndex: 'company',
                key: 'company',
                filters: this.state.company_filter,
                onFilter: ( value, record ) => record.company.indexOf(value) === 0,
            },
            {
                title: 'Status',
                dataIndex: 'employee_status',
                key: 'employee_status',
                filters: [
                    { text: 'Active', value: 'active' },
                    { text: 'Terminated', value: 'terminated' },
                    { text: 'Deceased', value: 'deceased' },
                    { text: 'Resigned', value: 'resigned' }
                ],
                onFilter: ( value, record ) => record.employee_status.indexOf(value) === 0,
            },
            {
                title: 'Date of Joining',
                dataIndex: 'date_of_joining',
                key: 'date_of_joining',
            },
            {
                title: 'Date of Exit',
                dataIndex: 'date_of_exit',
                key: 'date_of_exit',
            },
            {
                title: 'Total Leave Benefit',
                key: 'total_leave_benefit',
                render: ( data ) => <span>
                    { 
                       this.handletotal_leave_benefit( data ) 
                    }
                </span>
            },
            {
                title: 'Total Leave Taken',
                key: 'total_leave_taken',
                render: ( data ) => <span>
                    { 
                       this.handletotal_leave_taken( data )
                    }
                </span>
            },
            {
                title: 'Current Leave Balance',
                key: 'current_leave_balance',
                render: ( data ) => <span>
                    { 
                        this.handlecurrent_leave_balance( data )
                    }
                </span>
            }
        ];

        const summary_columns = [
            {
                title: 'Year',
                dataIndex: 'year',
                key: 'year',
            },
            {
                title: 'Joining Date',
                dataIndex: 'joining_date',
                key: 'joining_date',
            },
            {
                title: 'Year End',
                dataIndex: 'year_end',
                key: 'year_end',
            },
            {
                title: 'Total No Of Days',
                dataIndex: 'total_number_of_days',
                key: 'total_number_of_days',
            },
            {
                title: 'No Of Months',
                dataIndex: 'no_of_months',
                key: 'no_of_months',
            },
            {
                title: 'Acquired Days Per Month',
                dataIndex: 'acquired_days_per_month',
                key: 'acquired_days_per_month',
            },
            {
                title: 'Yearly Leave Benefit',
                dataIndex: 'yearly_leave_benefit',
                key: 'yearly_leave_benefit',
            },
            {
                title: 'Total Leave Benefit',
                dataIndex: 'total_leave_benefit',
                key: 'total_leave_benefit',
            },
            {
                title: 'Total Leave Taken',
                dataIndex: 'total_leave_taken',
                key: 'total_leave_taken',
            },
            {
                title: 'Unused Leaves',
                dataIndex: 'unused_leaves',
                key: 'unused_leaves',
            }

        ];

        const sub_summary_columns = [
            {
                title: 'Year',
                dataIndex: 'year',
                key: 'year'
            },
            {
                title: 'Month',
                dataIndex: 'month',
                key: 'month'
            },
            {
                title: 'Leave Count',
                dataIndex: 'count',
                key: 'count'
            },
        ];

        const sub_date_summary_columns = [
            {
                title: 'Month',
                dataIndex: 'month',
                key: 'month'
            },
            {
                title: 'Date',
                dataIndex: 'date',
                key: 'date'
            },
            {
                title: 'Day',
                dataIndex: 'day',
                key: 'day'
            },
        ];

        return (
            <div>
                
                <Row>
                    <Col span={24} style={{ paddingBottom: '17px' }}>
                        <CSVLink 
                            headers={headers}
                            filename={"Work-f-home-Report.csv"}
                            data={ this.state.download_csv } target="_blank" >
                            <Button className="fl_right clearfix" type="default">Download CSV</Button></CSVLink >                    
                    </Col>
                </Row>

                <Table columns={ columns } dataSource={ this.state.data } scroll={{ x: 1300 }} 
                    expandedRowRender={ data => <div style={{ backgroundColor: '#fff', padding: '20px' }}>
                        <Row gutter={12}>
                            <Col span={24}>
                                <h3>Leave Summary</h3>  
                                <Table 
                                    className="summary_wrapper" 
                                    pagination={false} 
                                    size={'small'} 
                                    bordered={false} 
                                    columns={ summary_columns } 
                                    dataSource={ data.summary }
                                    expandedRowRender={ value => <div style={{ backgroundColor: '#fff', padding: '20px' }}>
                                        <Row gutter={12}>
                                            <Col span={24}>
                                                <Table
                                                    className="summary_wrapper" 
                                                    pagination={false} 
                                                    size={'small'} 
                                                    bordered={false} 
                                                    columns={ sub_summary_columns } 
                                                    dataSource={ value.leave_detail }
                                                    expandedRowRender={ val => <div style={{ backgroundColor: '#fff', padding: '20px' }}> 
                                                    <Row gutter={12}>
                                                        <Col span={24}>
                                                            <Table
                                                                className="summary_wrapper" 
                                                                pagination={false} 
                                                                size={'small'} 
                                                                bordered={false} 
                                                                columns={ sub_date_summary_columns } 
                                                                dataSource={ val.dates } />
                                                            
                                                        </Col>
                                                    </Row>
                                                </div> }/>
                                            </Col>
                                        </Row>
                                    </div>} />
                            </Col>
                        </Row>
                </div>} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/reports/childs/workfhome_summary.js